var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dashboard-dropdown-section',{attrs:{"title":"Requests Received","type":"locum-booking-requests-received","items-shown":5,"items":_vm.requests,"event-name":"load-locum-booking-requests"},on:{"load-locum-booking-requests":_vm.loadMore}})}
var staticRenderFns = []

export { render, staticRenderFns }